import { BaseSlideShowPanel, SlideBase } from "./BaseSlideShowPanel";
import { ObjectBuilder, Image3D, Rectangle3D } from "@dreamcam/babylon-tools";
import { text } from "../../../TextResources";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
export class AnnouncementBaseSlideShowPanel extends BaseSlideShowPanel {
    async _getSlideTextsAsync() {
        return text.featureAnnouncement_slides;
    }
    _createSlide(position, totalSlides, layout, content, mesh, func) {
        return new AnnouncementSlide(position, totalSlides, layout, content, mesh, func);
    }
    _close() {
        this._beforeClose();
        super._close();
    }
}
export class AnnouncementSlide extends SlideBase {
    constructor(position, totalSlides, layout, content, mesh, func) {
        super(position, totalSlides, layout, content, mesh, func);
        const title = ObjectBuilder.createTextBlock3D(this._mesh, "announcementTitle", content.header ?? "-", layout.header);
        this.addControl(title);
        const rectangle = new Rectangle3D(`announcementSlideImageContainer${position}`);
        rectangle.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        rectangle.topInPixels = this._mesh.m2px(layout.image.top);
        rectangle.heightInPixels = this._mesh.m2px(layout.image.height);
        rectangle.widthInPixels = this._mesh.m2px(layout.image.width);
        rectangle.cornerRadius = this._mesh.m2px(layout.image.radius);
        rectangle.thickness = 0;
        this.addControl(rectangle);
        const image = new Image3D(`announcementSlideImage${position}`, layout.image.src);
        image.heightInPixels = this._mesh.m2px(layout.image.height);
        image.widthInPixels = this._mesh.m2px(layout.image.width);
        image.zIndex = -1;
        rectangle.addControl(image);
        this.AddNextButton(text.featureAnnouncement_button);
        this.AddCloseButton();
    }
}
